/**
 * 验证手机号格式
 */
const checkPhoneNum = function (phoneNum) {
  var myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  var tempStatus = false;
  if (phoneNum.length == 11 && myreg.test(phoneNum)) {
    tempStatus = true;
  }
  return tempStatus;
}

// 函数防抖
const debounce = (fn, t) => {
  let delay = t || 200;
  let timer;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  }
}
/**
 * 获取url参数值(post请求需要)
 */
function GetQueryValue1(queryName) {
  var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}

export {
  checkPhoneNum,
  GetQueryValue1,
  debounce
}



// WEBPACK FOOTER //
// ./src/utils/utils.js